<svg class="stacked-area-chart">
  <defs>
    <linearGradient id="linearGradient0" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="var(--chart-color-bad-path-color)" stop-opacity="0.5"></stop>
    </linearGradient>
    <linearGradient id="linearGradient1" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="var(--chart-color-expected-path-color)" stop-opacity="0.5"></stop>
    </linearGradient>
    <linearGradient id="linearGradient2" x1="0%" y1="100%" x2="25%" y2="15%">
      <stop offset="0%" stop-color="white" stop-opacity="0"></stop>
      <stop offset="100%" stop-color="var(--chart-color-good-path-color)" stop-opacity="0.5"></stop>
    </linearGradient>
  </defs>
</svg>

<div id="stacked-area-chart-tooltip" class="stacked-area-chart-tooltip">
  <p>{{ translations.expectedValue }} {{ tooltipData.value | translateNumber: customerLanguage }}</p>
  <p>{{ translations.investment }} {{ tooltipData.invested | translateNumber: customerLanguage }}</p>
  <p>{{ translations.year }} {{ tooltipData.year }}</p>
</div>

<div class="stacked-area-chart__legend">
  <div
    class="stacked-area-chart__legend-item"
    *ngFor="let item of data.columns; let i = index"
    (click)="handleSelection(i - 1)"
    [class.inactive]="selectedIndex !== null && selectedIndex !== i - 1"
  >
    {{ translations ? translations[item] : '' }}
  </div>
</div>
